import { AxiosResponse } from 'axios'

import axios from '../../axios'

export const settlementsPdf = async (
  year: number,
  month: number,
  agencyCode?: string
): Promise<AxiosResponse> => {
  const response = await axios
    .get(`/api/campaigns/settlements/pdf/download`, {
      params: { agencyCode, year, month },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
